module.exports = __webpack_public_path__ + "img/41_15.ded6622b.png";